<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="this.$route.meta.keepAlive"></router-view>
            <!--这里是会被缓存的组件-->
        </keep-alive>
        <router-view v-if="!this.$route.meta.keepAlive"></router-view>
    </div>
</template>
<script>
import { mapMutations, mapGetters } from "vuex";
export default {
    created() {
        this.getTheme();
    },
    methods: {
        ...mapMutations(["EVENT"]),
        //设置主题
        getTheme() {
            let dataCode = this.iStorage.get("paramCode");
            // let eventData = {};
            let eventData = this.iStorage.get('eventData')||{}
            
            if(!eventData.proposalId){
                eventData.proposalId = this.iStorage.get("ProposalId") || ''
            }
            let tenant_code = eventData.tenant_code || this.iStorage.get("tenant_code") || "roche";
            eventData.tenant_code = this.iStorage.get("tenant_code")
            if (dataCode) {
                dataCode = window.atob(dataCode);
                dataCode = window.decodeURIComponent(dataCode);
                dataCode = JSON.parse(dataCode);
                window.document.documentElement.setAttribute(
                    "data-theme",
                    tenant_code
                );
                if (dataCode.search) {
                    eventData = { 
                        isQuery: true,
                        ...eventData,
                    };
                    eventData.searchGPS = {
                        latitude: dataCode.latitude,
                        longitude: dataCode.longitude,
                        addressName: dataCode.city,
                        city: dataCode.city
                    };
                }
            } else {
                eventData = {
                    ...eventData,
                }
                if(this.iStorage.get("itemId")) {
                    eventData = {
                        ...eventData,
                        itemId: this.iStorage.get("itemId"),
                    }
                }
                this.$cookies.setCookie("eventData", JSON.stringify(eventData));
                this.$cookies.setCookie("eventData", JSON.stringify(eventData), {
                    domain: window.idomain
                });
                eventData = {
                    ...eventData,
                    isQuery: this.iStorage.get("isQuery"),
                    mcOnly: parseInt(this.iStorage.get("mcOnly")),
                    merchantsType:
                        parseInt(this.iStorage.get("merchantsType")) || 1,
                    isWeb: this.iStorage.get("isWeb"),
                };
                //根据租户更换皮肤颜色
                window.document.documentElement.setAttribute(
                    "data-theme",
                    tenant_code
                );
            }
            this["EVENT"](eventData);
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/public.scss";
@import "@/assets/scss/theme.scss";
html,
body {
    width: 100%;
    height: 100%;
    color: $smart-color-primary;
    font-size: $smart-fonsize-base;
    background-color: $smart-color-white;

    * {
        box-sizing: border-box;
    }
}
</style>
